import Vue from 'vue'
import { handleize } from 'lib/util'
import inViewport from 'in-viewport'

Vue.component('certification-icons', {
  props: [
    'icons',
    'theme',
    'noLabels',
    'isVariant'
  ],
  data () {
    const iconsData = HU.certificate_icons || []
    return {
      iconsData,
      isInViewport: false
    }
  },
  computed: {
    currentIcons () {
      if (!this.icons) return []
      if (!this.isVariant) {
        return this.icons.map((icon) => {
          return this.iconsData.find(({handle}) => handle === handleize(icon))
        }).filter(v => v)
      } else {
        return this.icons
      }
    }
  },
  mounted () {
    inViewport(this.$el, () => {
      this.isInViewport = true
    })
  },
  template: `
    <ul class="certificate-icons f aic jcc fw">
      <li class="certificate-icons__icon" v-for="icon in currentIcons">
        <template v-if="isInViewport">
          <img :title="icon.label" :src="theme == 'light' ? icon.light_icon : icon.dark_icon" :alt="icon.dark_alt ? icon.dark_alt : icon.label">
        </template>
        <span v-if="!noLabels" class="p2" :class="{ white: theme === 'light' }" v-html="icon.label"></span>
      </li>
    </ul>
  `
})
